<template>
    <div>
        <div :class="{'stack-s': showAmount}">
            <v-popper-select
                label="Payment Adjustment type"
                :options="paymentMethodOptions"
                :value="paymentInstruction.method"
                :validate="validate.method"
                @input="value => updateInstruction('method', value)"/>
        </div>
        <div v-if="showAmount" class="grid-fitted">
            <div class="grid-item no-flex">
                <v-popper-select
                    class="inline-xs"
                    label="Amount"
                    :options="paymentTypeOptions"
                    :value="paymentInstruction.type"
                    :validate="validate.type"
                    @input="value => updateInstruction('type', value)"/>
            </div>
            <div class="grid-item">
                <v-inline-input
                    :class="{'stack-s': showPartialText}"
                    class="rule-action-schedule-payment-inline-inputs"
                    v-if="paymentInstruction.method"
                    v-model="paymentInstruction.value"
                    :validate="validate.value"/>
                <template v-if="showPercent">%</template>
            </div>
            <div v-if="showPartialText" class="grid-item grid-item-full">
                to be credited towards the user's balance
            </div>
        </div>
    </div>
</template>
<script>
    import _ from '@/common/helpers';
    import {PaymentInstructionModel} from '@/common/models/rules/actions/schedule-payment-retry-action-model';
    import {vPopperSelect, vInlineInput} from '@/components/form';

    export default {
        name: 'define-payment-view',
        components: {
            vPopperSelect,
            vInlineInput,
        },
        props: {
            validate: {
                type: Object,
            },
            paymentInstruction: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                paymentMethodOptions: Object.values(
                    PaymentInstructionModel.Methods,
                ).map(value => ({
                    value,
                    label: value === 'none' ? 'Full amount' : `${_.unKebabCase(value)} amount`,
                })),
                paymentTypeOptions: Object.values(
                    PaymentInstructionModel.Types,
                ).map(value => ({
                    value,
                    label: _.unKebabCase(value),
                })),
            };
        },
        computed: {
            showAmount() {
                return this.paymentInstruction.method !== PaymentInstructionModel.Methods.none;
            },
            showPercent() {
                return this.paymentInstruction.type === PaymentInstructionModel.Types.percent;
            },
            showPartialText() {
                return this.paymentInstruction.method === PaymentInstructionModel.Methods.partial;
            },
        },
        methods: {
            updateInstruction(name, value) {
                const data = {
                    [name]: value,
                };
                if (name === 'method' && value !== PaymentInstructionModel.Methods.none) {
                    data.type = PaymentInstructionModel.Types.fixed;
                }
                this.$emit('update', data);
            },
        },
    };
</script>
